import { assertNever } from "@p0security/util/assertNever";

import type { ClickHouseConnectorHosting } from "./types.ts";

/** Says where a connector runs, such as "the Lambda function p0-clickhouse in
 * AWS account 123456789012, region us-west-2", for an admin to find it by. */
export const renderHosting = (hosting: ClickHouseConnectorHosting) => {
  switch (hosting.type) {
    case "aws":
      return `the Lambda function ${hosting.connectorName} in AWS account ${hosting.accountId}, region ${hosting.connectorRegion}`;
    case "gcp":
      return `the Cloud Run service ${hosting.connectorName} in Google Cloud project ${hosting.projectId}, region ${hosting.connectorRegion}`;
    default:
      throw assertNever(hosting);
  }
};

/** Refuses an API key secret outside its connector's cloud: the connector
 * reads the secret with its own cloud identity. */
export const VAULT_OUTSIDE_CONNECTOR_CLOUD =
  "The API key's secret must be in the connector's cloud: AWS Secrets Manager for a connector on AWS Lambda, or Google Secret Manager for one on Cloud Run.";
